"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopOpenStatusToJSON = exports.ShopOpenStatusFromJSONTyped = exports.ShopOpenStatusFromJSON = exports.ShopOpenStatus = void 0;
/**
 *
 * @export
 */
exports.ShopOpenStatus = {
    Open: 0,
    Expired: 1,
    NotActivated: 2
};
function ShopOpenStatusFromJSON(json) {
    return ShopOpenStatusFromJSONTyped(json, false);
}
exports.ShopOpenStatusFromJSON = ShopOpenStatusFromJSON;
function ShopOpenStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ShopOpenStatusFromJSONTyped = ShopOpenStatusFromJSONTyped;
function ShopOpenStatusToJSON(value) {
    return value;
}
exports.ShopOpenStatusToJSON = ShopOpenStatusToJSON;
